import type { Comando } from "../data/comandos";

/**
 * Filtra el catálogo a los comandos visibles según los PERMISOS del
 * usuario (sin `permisos` → visible para todos).
 */
export function comandosDisponiblesPara(
  comandos: ReadonlyArray<Comando>,
  permisos: ReadonlyArray<string>
): Comando[] {
  return comandos.filter((c) => {
    if (!c.permisos) return true;
    return c.permisos.some((p) => permisos.includes(p));
  });
}

/**
 * Filtra por texto libre · busca en label + descripción + keywords.
 * Case-insensitive · trim de borders. Empty query devuelve todo.
 */
export function filtrarPorTexto(
  comandos: ReadonlyArray<Comando>,
  texto: string
): Comando[] {
  const q = texto.trim().toLowerCase();
  if (!q) return comandos.slice();
  return comandos.filter((c) => {
    const blob = `${c.label} ${c.descripcion ?? ""} ${c.keywords ?? ""}`.toLowerCase();
    return blob.includes(q);
  });
}
